import React from 'react';

import { useQuery } from '@tanstack/react-query';

import Checkbox from '../../Form/Checkbox';

import classes from './styles.module.css';
import TermsOfServiceService from '../../../services/TermsOfServiceService';

export default function TermsOfService({
  value,
  setValue,
  name,
  hasTriedToSubmit,
}) {
  const { data: termsOfService } = useQuery({
    queryKey: ['terms_of_service'],
    queryFn: TermsOfServiceService.getTermsOfService,
  });

  return (
    <div className="flex flex-col">
      <button
        type="button"
        className="mb-2"
        onClick={() => window.open('/lender_terms_of_service', '_blank')}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="icon icon-tabler icon-tabler-file-symlink"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="#2c3e50"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M4 21v-4a3 3 0 0 1 3 -3h5" />
          <path d="M9 17l3 -3l-3 -3" />
          <path d="M14 3v4a1 1 0 0 0 1 1h4" />
          <path d="M5 11v-6a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-9.5" />
        </svg>
      </button>
      <div className="h-96 overflow-y-auto">
        <div
          className={classes.text}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: termsOfService?.content }}
        />
      </div>
      <div className="mt-4">
        <Checkbox
          label={`I accept these terms of service on behalf of ${name}`}
          value={value}
          onChange={() => setValue((prevState) => !prevState)}
          name="terms_of_service"
        />
        {hasTriedToSubmit && !value && (
          <p className="text-red-500 text-sm mt-1">This field is required</p>
        )}
      </div>
    </div>
  );
}
